module.exports = __webpack_public_path__ + "3df3a9723c3eb95b55db66104f8b347a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/features/screens/fitness/large.png
// module id = 1811
// module chunks = 1